import {Component} from '@angular/core';
/**
 * \@title Card with multiple sections
 */
export class CardFancyExample {static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'card-fancy-example',
  templateUrl: 'card-fancy-example.html',
  styleUrls: ['card-fancy-example.css'],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function CardFancyExample_tsickle_Closure_declarations() {
/** @type {?} */
CardFancyExample.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CardFancyExample.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
